/* @ngInject */
function AuditModelsController ($scope, $rootScope, $translate, $state, $q, BriefingService, UdsModalService, SegmentService, ToastService, CampaignService, ConfirmationModalService) {
  const getUpgradeCompanyPlanDialogController = () => $q.when(import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller'))
  const getBindCampaignDialogController = () => $q.when(import('../../../core/dialogs/bind-campaign/bind-campaign-dialog.controller'))

  const ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY = 'ANALYTICS.ADVANCED_DASHBOARDS'
  const CHECKLIST_MAX_BRIEFINGS_ACCESS_KEY = 'CHECKLIST.MAX_BRIEFINGS'
  const AUDIT_MODELS_RELOAD = 'audit.audit-models-reload'

  const deregisterAuditModelsReload = $scope.$on(AUDIT_MODELS_RELOAD, () => {
    activate()
  })

  $scope.briefingsCount = 0
  $scope.currentPage = 1

  $scope.flags = {
    loading: false
  }

  $scope.briefings = []

  $scope.companyFeatures = {
    maxBriefings: {
      maxReached: false,
      data: {},
      tooltip: ''
    },
    notHasAdvancedDashboardsAccess: false
  }

  $scope.newBriefingDisabled = false

  $scope.companyFeatures = {
    campaigns: {
      access: false
    }
  }

  $scope.top = 20
  $scope.skip = 0

  const api = {
    activate,
    getUpgradeCompanyPlanDialogController,
    _successArchiveBriefing,
    _errorArchiveBriefing,
    _openUpgradeCompanyPlanDialog,
    _getCompanyBriefings,
    _successGetCompanyBriefings,
    _errorGetCompanyBriefings,
    _finallyGetCompanyBriefings,
    _successGetCompanyFeatures,
    _errorGetCompanyFeatures,
    _addRouteParamsToBriefings,
    _unbindAuditBriefingFromCampaign
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getCompanyBriefings()
  }

  $scope.$on('$destroy', deregisterAuditModelsReload)

  $scope.handleEditButton = id => {
    $state.go('admin.auditBriefing', { id })
  }

  $scope.handleNewBriefing = (event) => {
    if (event.detail.pricing) {
      api._openUpgradeCompanyPlanDialog($scope.companyFeatures.maxBriefings?.data)
    } else {
      $state.go('admin.auditBriefingNew')
    }
  }

  $scope.handleOpenAnalytics = (event, routeParams) => {
    const { pricing } = event.detail

    if (pricing) {
      const featureName = $translate.instant('dataPages.advancedDashboards.featureName')
      const featureSlug = ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY

      return api._openUpgradeCompanyPlanDialog({
        featureName,
        featureSlug
      })
    }

    const analyticsChecklistSlug = 'analytics.dashboard'
    $state.go(analyticsChecklistSlug, routeParams)

    SegmentService.track('checklist-models-answers-click')

    if (window.clarity) {
      window.clarity('set', 'checklist-models-answers-click', null)
    }
  }

  $scope.deleteBriefing = briefing => {
    const modalConfig = {
      title: $translate.instant('delete'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('yesDelete'),
      onConfirm: () => {
        BriefingService.archiveBriefing(briefing.id)
          .then(api._successArchiveBriefing)
          .catch(api._errorArchiveBriefing)
      }
    }

    if (briefing.campaignId) {
      modalConfig.htmlDescription = CampaignService.getArchiveHtmlDescription(briefing.campaignName, 'delete')
    } else {
      modalConfig.description = $translate.instant('areYouSureDeleteChecklistModel')
    }

    ConfirmationModalService.createModal(modalConfig)
  }

  $scope.openBindCampaignDialog = (briefing) => {
    getBindCampaignDialogController().then(({ BindCampaignDialogController }) => {
      const bindCampaignDialog = UdsModalService.createModal({
        controller: BindCampaignDialogController,
        modalName: 'bindCampaignDialog',
        data: {
          currentModule: 'checklists',
          assetId: briefing.id,
          campaignId: briefing.campaignId,
          campaignName: briefing.campaignName
        },
        onClose: (bindDetails) => {
          if (bindDetails) {
            api._unbindAuditBriefingFromCampaign(bindDetails)
          }
        }
      })

      bindCampaignDialog.open()
    })
  }

  $scope.onPageSelect = (event) => {
    $scope.currentPage = event.detail.currentPage
    $scope.skip = ($scope.currentPage - 1) * $scope.top
    api._getCompanyBriefings()
  }

  function _unbindAuditBriefingFromCampaign (bindDetails) {
    BriefingService.unbindBriefingFromCampaign(bindDetails)
      .then(() => {
        ToastService.defaultSuccessToast()
        $scope.$emit(AUDIT_MODELS_RELOAD)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _successArchiveBriefing () {
    api.activate()
    ToastService.defaultSuccessToast()
  }

  function _errorArchiveBriefing () {
    ToastService.defaultErrorToast()
  }

  function _openUpgradeCompanyPlanDialog (pricingData) {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: pricingData
      })
      upgradeCompanyPlanDialog.open()
    })
  }

  function _successGetCompanyFeatures ({ features }) {
    const { billingPackage } = $rootScope.companyWithBillingPackage
    const briefingsLimit = features[CHECKLIST_MAX_BRIEFINGS_ACCESS_KEY].limit
    const notHasAnalyticsAdvancedDashboards = !features[ANALYTICS_ADVANCED_DASHBOARDS_ACCESS_KEY]

    $scope.companyFeatures.maxBriefings = {
      maxReached: briefingsLimit ? $scope.briefings.length >= briefingsLimit : false,
      data: {
        featureName: $translate.instant('billingFeatures.checklistMaxBriefings'),
        featureSlug: CHECKLIST_MAX_BRIEFINGS_ACCESS_KEY
      },
      tooltip: billingPackage.planId === 1
        ? $translate.instant('billingTooltips.maxBriefingsLimitPro')
        : $translate.instant('billingTooltips.maxBriefingsLimitEnterprise'),
      briefingsLimit
    }

    $scope.companyFeatures.campaigns = {
      access: !!features['CAMPAIGNS.ACCESS']
    }

    $scope.companyFeatures.notHasAdvancedDashboardsAccess = notHasAnalyticsAdvancedDashboards
  }

  function _errorGetCompanyFeatures (error) {
    ToastService.defaultErrorToast()
    console.error(error)
  }

  function _getCompanyBriefings () {
    $scope.flags.loading = true

    return BriefingService.getCompanyBriefings('AUDIT', false, '', $scope.top, $scope.skip)
      .then(api._successGetCompanyBriefings)
      .catch(api._errorGetCompanyBriefings)
      .finally(api._finallyGetCompanyBriefings)
  }

  function _successGetCompanyBriefings (briefings) {
    $scope.briefings = api._addRouteParamsToBriefings(briefings.rows)

    $scope.briefingsCount = briefings.count
    $rootScope.getCompanyFeaturesAndAddons()
      .then(api._successGetCompanyFeatures)
      .catch(api._errorGetCompanyFeatures)
  }

  function _errorGetCompanyBriefings (error) {
    $scope.briefings = []
    ToastService.defaultErrorToast()
    console.error(error)
  }

  function _finallyGetCompanyBriefings () {
    $scope.flags.loading = false
  }

  function _addRouteParamsToBriefings (briefings) {
    return briefings.map(briefing => {
      return {
        ...briefing,
        routeParams: {
          slug: briefing.dataPageSlug
        }
      }
    })
  }
}

export { AuditModelsController }
